import { h, render } from "preact";
import QuoteModal from "./quote-modal/quote-modal";
import "./save-quote-wrapper";

class SaveQuote extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const data = window.scrapeSectionData(this);

    render(<QuoteModal data={data} />, this.querySelector("[data-container]"));
  }
}

if (!customElements.get("save-quote")) {
  customElements.define("save-quote", SaveQuote);
}
